import React, { Component } from 'react';
import { drizzleConnect } from 'drizzle-react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';

class OwnedList extends Component {
  constructor(props, context) {
    super(props);
    this.contract = context.drizzle.contracts.Alias;
    this.methods = this.contract.methods;
    this.web3Util = context.drizzle.web3.utils;
    this.postAliasForSale = this.postAliasForSale.bind(this);
    this.state = {
      accounts: Object.keys(this.props.accounts).map(idx => this.props.accounts[idx])
    };
  }

  handleSale(alias, price) {
    if (price) {
      return this.getAddressForAlias(alias).then(address => {
          const isValidAddress = this.state.accounts.includes(address);
          if (isValidAddress) {
            return this.postAliasForSale(alias, price);
          }
      });
    }
  }

  postAliasForSale(alias, price) {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.putForSale.cacheSend(bytes, price);
  }

  getAddressForAlias(alias) {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.get(bytes).call();
  }

  getPrice(alias) {
    const convertCurrencyFromWei = (num) => this.web3Util.fromWei(num);
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.getPrice(bytes).call().then(price => {
      return price === '0' ? 'Not for sale' : Number(convertCurrencyFromWei(price))
    });
  }

  render() {
    if (this.props.list && this.props.list[0] !== undefined) {
      const list = this.props.list;
      const $list = list.map(({alias, price}) => {
        const saleAction = (e) => {
          const $saleContainer = e.target.previousElementSibling;
          const price = $saleContainer.querySelector('input').value;
          if (!isNaN(price) && !!price) {
            const weiCurrency = this.web3Util.toWei(price);
            this.handleSale(alias, weiCurrency);
          }
        };
        const priceText = price > 0 ? `Listed Sale Price: ${price} ETH` :
        <div className="container">
          <div className="sale-container">
            <input className="sell-value" placeholder='Sale Price' />
          </div>
          <button onClick={saleAction}>SELL</button>
        </div>;
        return (
        <div className="alias-container" key={alias}>
          <Link className={"name" + (price > 0 ? '' : ' sell')} to={"/e/" + alias}>etherdns:{alias}</Link>
          <div className="price">{priceText}</div>
        </div>
        );
      });
      return (
        <div className="alias-list">
          <div>YOUR COLLECTION</div>
          {$list}
        </div>
      );
    } else if (!this.props.list || (this.props.list && this.props.list[0] === undefined)) {
      return (
        <div className="alias-list">
          <div>YOUR COLLECTION</div>
          Looking a little empty there. Get them fast before they're gone!
        </div>

      );
    } else {
      return null;
    }
  }
}

OwnedList.contextTypes = {
  drizzle: PropTypes.object,
  contracts: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    contracts: state.contracts,
    accounts: state.accounts
  }
};

export default drizzleConnect(OwnedList, mapStateToProps);


// WEBPACK FOOTER //
// ./src/components/OwnedList.js